import { render, staticRenderFns } from "./LeadGooseRegistModal.vue?vue&type=template&id=3471fc32&scoped=true&"
import script from "./LeadGooseRegistModal.vue?vue&type=script&lang=js&"
export * from "./LeadGooseRegistModal.vue?vue&type=script&lang=js&"
import style0 from "./LeadGooseRegistModal.vue?vue&type=style&index=0&id=3471fc32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3471fc32",
  null
  
)

export default component.exports